import { Fragment } from 'react';
import BlogList from '../../components/BlogList/BlogList.jsx'
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import logo from '../../images/logo-2.svg';
import './BlogPage.scss';

const BlogPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={logo} isSecondary={true} />

            {/* Hero Section */}
            <section className="blog-hero-section">
                <div className="hero-overlay"></div>
                <div className="container">
                    <div className="hero-content">
                        <h1>Insights in Regenerative Medicine</h1>
                        <p className="hero-subtitle">
                            Expert articles and updates from Dr. Eugene Pereira on stem cell science and regenerative therapies.
                        </p>
                    </div>
                </div>
            </section>

            <BlogList />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogPage;

